import { render, staticRenderFns } from "./PaginatedDataTable.vue?vue&type=template&id=5bf594b4&scoped=true&"
import script from "./PaginatedDataTable.vue?vue&type=script&lang=ts&"
export * from "./PaginatedDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf594b4",
  null
  
)

export default component.exports